/* eslint-disable max-len */
import Image1 from '../images/tre-kr4.jpg'
import Image2 from '../images/slide22.jpg'
import Image3 from '../images/window.jpg'
import Image4 from '../images/IMG_4444.jpg'

//

import ToteBag1 from '../images/totebag1.jpg'
import ToteBag2 from '../images/totebag2.jpg'
import ToteBag3 from '../images/totebag3.jpg'
import ToteBag4 from '../images/totebag4.jpg'
import TShirt1 from '../images/t-shirt1.jpg'
import TShirt2 from '../images/t-shirt_2.jpg'
import TShirt3 from '../images/t-shirt_3.jpg'
import TShirt4 from '../images/t-shirt_4.jpg'
import WallArt1 from '../images/wallart1.jpg'
import WallArt2 from '../images/wallart2.jpg'
import WallArt3 from '../images/wallart3.jpg'
import WallArt4 from '../images/wallart4.jpg'
import Boots from '../images/customized-boots.jpg'
import PencilCase from '../images/pencil-case.jpg'

export const sliderData = [
  {
    id: '0',
    img: Image1,
    text: 'THE NEW TRE KRONOR COLLECTION - CELEBRATING THE LOST CASTLE OF GAMLA STAN'
  },
  {
    id: '1',
    img: Image2,
    text: 'ART FOR WALLS - ARKIART 23'
  },
  {
    id: '2',
    img: Image3,
    text: 'LOOKING INWARD - 2023'
  },
  {
    id: '3',
    img: Image4,
    text: '....and MUCH more coming SOON'
  }
];

export const storeData = [
  {
    id: '1',
    img: ToteBag1,
    name: 'Tote-ally deconstructed 2023',
    // text: 'Inspired by the aftermath of the fire that demolished Stockholm\'s Tre Kronor castle in 1697',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Tote bags',
    color: ['black', 'gray', 'green'],
    price: 45
  },
  {
    id: '2',
    img: ToteBag2,
    name: 'Tote bag 2',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Tote bags',
    size: ['M', 'L', 'XL'],
    color: ['black', 'red', 'brown'],
    gender: 'male',
    price: 55
  },
  {
    id: '3',
    img: ToteBag3,
    name: 'Tote bag 3',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Tote bags',
    size: ['L', 'XL'],
    color: ['brown', 'gray', 'yellow'],
    gender: 'female',
    price: 75
  },
  {
    id: '4',
    img: ToteBag4,
    name: 'Tote bag 4',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Tote bags',
    size: ['M', 'L', 'XL'],
    color: ['gray', 'orange', 'blue'],
    gender: 'female',
    price: 25
  },
  {
    id: '5',
    img: TShirt1,
    name: 'T-Shirt 1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'T-Shirts',
    size: ['M', 'L', 'XL'],
    color: ['pink', 'salmon', 'white'],
    gender: 'female',
    price: 15
  },
  {
    id: '6',
    img: TShirt2,
    name: 'T-Shirt 2',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'T-Shirts',
    size: ['M', 'L', 'XL'],
    color: ['gray', 'purple', 'yellow'],
    gender: 'female',
    price: 25
  },
  {
    id: '7',
    img: TShirt3,
    name: 'T-Shirt 3',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'T-Shirts',
    size: ['M', 'L', 'XL'],
    color: ['black', 'orange', 'blue'],
    gender: 'male',
    price: 25
  },
  {
    id: '8',
    img: TShirt4,
    name: 'T-Shirt 4',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'T-Shirts',
    size: ['M', 'XL'],
    color: ['salmon', 'pink', 'tomato'],
    gender: 'male',
    price: 35
  },

  {
    id: '9',
    img: WallArt1,
    name: 'Painting 1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Wall art',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  },

  {
    id: '10',
    img: WallArt2,
    name: 'Painting 2',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Wall art',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  },

  {
    id: '11',
    img: WallArt3,
    name: 'Painting 3',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Wall art',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  },
  {
    id: '12',
    img: WallArt4,
    name: 'Painting 4',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Wall art',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  },
  {
    id: '13',
    img: Boots,
    name: 'Custom boots V1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Cool nonsense',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  },
  {
    id: '14',
    img: PencilCase,
    name: 'Pencil Case V1',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed dui nisi, venenatis ac convallis id, vehicula ac massa. Morbi ut augue volutpat tortor pretium pharetra at vitae ante.',
    type: 'Cool nonsense',
    size: ['S', 'L', 'XL'],
    color: ['white', 'brown', 'black'],
    gender: 'female',
    price: 85
  }]